import * as React from 'react';

import type { TimeSheetInfoVM, TimeSheetEntryInfoVM } from 'ab-viewModels/workOrder/submitForReviewRecap';
import type { FieldReportListItemVM } from 'ab-viewModels/workOrder/workOrderFieldReportCard.viewModel';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';

import TimeSheets from './TimeSheets';
import FieldReports from '../Shared/ReportsSummary/FieldReports';

interface OwnProps {
	approvedTimeSheets: TimeSheetInfoVM[];
	fieldReports: FieldReportListItemVM[];
	closeModal: () => void;
	onConfirm: () => void;
	showModal: boolean;
	signedUnapprovedTimeSheets: TimeSheetInfoVM[];
	timeSheetEntriesByAccountIdMap: Nullable<{ [accountId: number]: TimeSheetEntryInfoVM[]; }>;
	unsignedTimeSheets: TimeSheetInfoVM[];
	timezone: Nullable<string>;
}

type Props = OwnProps;

const MODAL_TITLE = 'Finalize Report';
const REPORTS_SUMMARY_DESCRIPTION_ALL_SIGNED = 'You are about to finalize the report. After this, following content will no longer be changeable. This action cannot be undone.';
const REPORTS_SUMMARY_DESCRIPTION_UNSIGNED = 'You are about to finalize the report and sign and approve all unsigned time sheets. After this, following content will no longer be changeable. This action cannot be undone.';

const getDescription = (hasUnsignedTimeSheets: boolean) => {
	if (hasUnsignedTimeSheets) {
		return REPORTS_SUMMARY_DESCRIPTION_UNSIGNED;
	}
	return REPORTS_SUMMARY_DESCRIPTION_ALL_SIGNED;
};

const FinalizeModal: React.FC<Props> = (props) => {
	const {
		approvedTimeSheets,
		fieldReports,
		closeModal,
		onConfirm,
		showModal,
		signedUnapprovedTimeSheets,
		timeSheetEntriesByAccountIdMap,
		unsignedTimeSheets,
		timezone,
	} = props;

	return (
		<CustomModal
			className="report-type-modal"
			closeModal={closeModal}
			modalStyle="info"
			showModal={showModal}
			size="md"
		>
			<CustomModal.Header
				closeModal={closeModal}
				title={MODAL_TITLE}
			/>
			<CustomModal.Body>
				<div className="report-submit-modal__text">{getDescription(!!unsignedTimeSheets?.length)}</div>
				<TimeSheets
					approvedTimeSheets={approvedTimeSheets}
					signedUnapprovedTimeSheets={signedUnapprovedTimeSheets}
					timeSheetEntriesByAccountIdMap={timeSheetEntriesByAccountIdMap}
					timezone={timezone}
					unsignedTimeSheets={unsignedTimeSheets}
				/>
				<FieldReports
					fieldReports={fieldReports}
				/>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Cancel"
					onClick={closeModal}
					style="secondary"
				/>
				<Button
					label="Continue"
					onClick={onConfirm}
					style="primary"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

export default React.memo(FinalizeModal);
